const countOffersMatchingPlan = (proposals, plan) => {
	return (
		proposals?.filter(
			item =>
				item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
				item?.status !== "REJECTED"
		)?.length || 0
	)
}

const countOffersMatchingPlanWithLoadingsOnly = (proposals, plan) => {
	return (
		proposals?.filter(
			item =>
				item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
				item?.basket?.[0]?.premium?.loadings?.length > 0 &&
				!item?.basket?.[0]?.exclusions &&
				item?.status !== "REJECTED"
		)?.length || 0
	)
}

const countOffersMatchingPlanWithExclusionsOnly = (proposals, plan) => {
	return (
		proposals?.filter(
			item =>
				item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
				item?.basket?.[0]?.premium?.loadings.length === 0 &&
				item?.basket?.[0]?.exclusions?.length > 0 &&
				item?.status !== "REJECTED"
		)?.length || 0
	)
}

const countOffersMatchingPlanWithLoadingsAndExclusions = (proposals, plan) => {
	return (
		proposals?.filter(
			item =>
				item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
				item?.basket?.[0]?.premium?.loadings?.length > 0 &&
				item?.basket?.[0]?.exclusions?.length > 0 &&
				item?.status !== "REJECTED"
		)?.length || 0
	)
}

const countOffersMatchingPlanWithRejectedStatus = (proposals, plan) => {
	return (
		proposals?.filter(
			item =>
				item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
				item?.status === "REJECTED"
		)?.length || 0
	)
}

// Go through address and check if placeOfResidence === hong_kong
const isHongKongResident = addresses => {
	const placeOfResidence = addresses
		?.find(item => item.type === "placeOfResidence")
		?.fields2?.find(field => field?.type === "address")?.value
	return placeOfResidence === "hong_kong" || placeOfResidence === "Hong Kong"
		? true
		: false
}

// Return accumulated ratio in loadings array
const getLoadingsRatioTotal = loadings => {
	return (
		loadings
			?.map(item => item.ratio)
			?.reduce((a, b) => {
				return a + b
			}, 0) || 0
	)
}

// Return loading code based on index param
const getLoadingCode = (loadings, index) => {
	return loadings?.[index]?.codeName?.code?.replace("vhis|", "") || null
}

const getExclusionCode = (exclusions, index) => {
	return exclusions?.[index]?.codeName?.code.replace("vhis|", "") || null
}

// Return rejection code based on index param
const getRejectionCode = (rejectionCodes, index) => {
	return rejectionCodes?.[index]?.code.replace("vhis|", "") || null
}

// NOTE: Accepted offer is a proposal with a created policy
const countAccpetedRejectedOffersMatchingPlan = (
	proposals,
	plan,
	isAccepted
) => {
	if (isAccepted) {
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.status !== "REJECTED" &&
					item?.policies?.length > 0
			)?.length || 0
		)
	} else
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.status === "REJECTED"
			)?.length || 0
		)
}

const countAccpetedRejectedOffersMatchingPlanWithLoadingsOnly = (
	proposals,
	plan,
	isAccepted
) => {
	if (isAccepted) {
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.basket?.[0]?.premium?.loadings?.length > 0 &&
					!item?.basket?.[0]?.exclusions &&
					item?.status !== "REJECTED" &&
					item?.policies?.length > 0
			)?.length || 0
		)
	} else
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.basket?.[0]?.premium?.loadings?.length > 0 &&
					!item?.basket?.[0]?.exclusions &&
					item?.status === "REJECTED"
			)?.length || 0
		)
}

const countAccpetedRejectedOffersMatchingPlanWithExclusionsOnly = (
	proposals,
	plan,
	isAccepted
) => {
	if (isAccepted) {
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.basket?.[0]?.premium?.loadings.length === 0 &&
					item?.basket?.[0]?.exclusions?.length > 0 &&
					item?.status !== "REJECTED" &&
					item?.policies?.length > 0
			)?.length || 0
		)
	} else
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.basket?.[0]?.premium?.loadings.length === 0 &&
					item?.basket?.[0]?.exclusions?.length > 0 &&
					item?.status === "REJECTED"
			)?.length || 0
		)
}

const countAccpetedRejectedOffersMatchingPlanWithLoadingsAndExclusions = (
	proposals,
	plan,
	isAccepted
) => {
	if (isAccepted) {
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.basket?.[0]?.premium?.loadings?.length > 0 &&
					item?.basket?.[0]?.exclusions?.length > 0 &&
					item?.status !== "REJECTED" &&
					item?.policies?.length > 0
			)?.length || 0
		)
	} else
		return (
			proposals?.filter(
				item =>
					item?.basket?.[0]?.product?.productId?.plan?.includes(plan) &&
					item?.basket?.[0]?.premium?.loadings?.length > 0 &&
					item?.basket?.[0]?.exclusions?.length > 0 &&
					item?.status === "REJECTED"
			)?.length || 0
		)
}

export {
	countOffersMatchingPlan,
	countOffersMatchingPlanWithLoadingsOnly,
	countOffersMatchingPlanWithExclusionsOnly,
	countOffersMatchingPlanWithLoadingsAndExclusions,
	countOffersMatchingPlanWithRejectedStatus,
	isHongKongResident,
	getLoadingsRatioTotal,
	getLoadingCode,
	getExclusionCode,
	getRejectionCode,
	countAccpetedRejectedOffersMatchingPlan,
	countAccpetedRejectedOffersMatchingPlanWithLoadingsOnly,
	countAccpetedRejectedOffersMatchingPlanWithExclusionsOnly,
	countAccpetedRejectedOffersMatchingPlanWithLoadingsAndExclusions
}
